import React from 'react';
import './InputLabel.scss';

export default function InputLabel({ children, label, className })
{
    return (
        <label className={'input-label ' + (className || '')}>{children||label}</label>
    );
}